var React = require('react');

function PadlockUnlockedInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinejoin":"round"},[React.createElement("g",{"strokeLinecap":"square","key":0},[React.createElement("path",{"d":"M53 26v30a4 4 0 0 1-4 4H15a4 4 0 0 1-4-4V26h42z","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M30.001 43.466a4 4 0 1 1 3.997 0c.002.024.002.048.002.072V47a2 2 0 1 1-4 0v-3.462l.001-.072z","fill":"currentColor","key":1})]),React.createElement("path",{"d":"M19 26v-8.5C19 10.044 25.044 4 32.5 4S46 9.544 46 17","stroke":"currentColor","strokeWidth":"2","key":1})]));
}

PadlockUnlockedInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = PadlockUnlockedInline;

PadlockUnlockedInline.default = PadlockUnlockedInline;
